import {Link} from 'react-router-dom'
import './NotFoundRoute.css'

const NotFoundRoute = () => (
  <main className="not-found-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/jobby-app-not-found-img.png"
      alt="not found"
      className="not-found-image"
    />
    <h1 className="not-found-heading" data-testid="notFoundHeading">
      Page Not Found
    </h1>
    <p className="not-found-description" data-testid="notFoundDescription">
      We are sorry, the page you requested could not be found
    </p>
    <Link to="/">
      <button type="button" className="home-button" data-testid="homeButton">
        Home
      </button>
    </Link>
  </main>
)

export default NotFoundRoute
